import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { ProfileConflictActivity } from 'shared/models/profile-conflict-review';

import { ProfileConflicts } from '../components/profile-conflicts';

interface RouterProps {
    view?: ProfileConflictActivity['section'];
}

// Preserve person-pair deep links when opening the combined conflict page.
const ProfileConflictsPageComponent: React.FC<RouteComponentProps<RouterProps>> = ({ match, location }) => {
    const { view = 'needs-resolution' } = match.params;
    const qs = new URLSearchParams(location.search);
    const personId1 = qs.get('personId1');
    const personId2 = qs.get('personId2');
    return <ProfileConflicts view={view} personId1={personId1} personId2={personId2} />;
};

export const ProfileConflictsPage = withRouter(ProfileConflictsPageComponent);
